import { render, staticRenderFns } from "./RescueOfOverseasService.vue?vue&type=template&id=298751c8&scoped=true&"
import script from "./RescueOfOverseasService.vue?vue&type=script&lang=js&"
export * from "./RescueOfOverseasService.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfOverseasService.vue?vue&type=style&index=0&id=298751c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298751c8",
  null
  
)

export default component.exports